export type StudySecondAuthenticationConfig = {
  patientSecondAuthenticationSessionInMinutes: number;
};

export const StudySecondAuthenticationConfig = {
  DEFAULT_SECOND_AUTHENTICATION_SESSION_IN_MINUTES: 30,
};
